/**
 * Tautan "kembali" di detail tugas — MURNI.
 *
 * ADA KARENA tautannya selalu berbunyi "← Tugas saya" ke `/tasks`, apa pun asal kunjungannya
 * (temuan review 12 Sep 2026 item 13). Seorang manajer yang membuka detail dari Kelola Tugas lalu
 * menekan kembali mendarat di layar KURIR — bukan layar tempat ia baru saja berada, dan tanpa tugas
 * itu muncul di sana sama sekali bila ia bukan penerimanya.
 *
 * Asalnya dibawa lewat `state` pada `<Link>` (react-router), BUKAN query string: URL detail tugas
 * tetap sama persis siapa pun yang membukanya dan dari mana pun — hanya riwayat navigasi klien
 * yang tahu asalnya, dan itu justru yang seharusnya menentukan tautan kembali.
 */

export const ASAL_KELOLA_TUGAS = 'kelola-tugas';
export const ASAL_TUGAS_SAYA = 'tugas-saya';

export interface TautanKembaliTugas {
  readonly to: string;
  readonly label: string;
}

const KELOLA: TautanKembaliTugas = { to: '/tasks/manage', label: '← Kelola Tugas' };
const SAYA: TautanKembaliTugas = { to: '/tasks', label: '← Tugas saya' };

/**
 * `asal` datang dari `location.state`, jadi tipenya `unknown` di batas router — nilai apa pun
 * selain dua penanda yang dikenal (termasuk `undefined`: kunjungan langsung lewat URL, tautan
 * notifikasi, atau riwayat browser yang tidak membawa state) jatuh ke "Tugas saya", perilaku yang
 * SAMA dengan sebelum perbaikan ini — bukan perilaku baru yang bisa mengejutkan asal lain.
 */
export function tautanKembaliTugas(asal: unknown): TautanKembaliTugas {
  return asal === ASAL_KELOLA_TUGAS ? KELOLA : SAYA;
}
